{
  "columns": [],
  "buttons": [],
  "apiDetails": "mass-adjustment-list.json",
  "pageName": "purchaseBatchResultList",
  "orderByColumn": ["modifiedDate"],
  "orderBy": ["desc"]
}
